import type React from "react"
interface SectionHeadingProps {
  children: React.ReactNode;
  subtitle?: React.ReactNode;
  className?: string;
  headingColor?: string;
  underlineColor?: string;
  subtitleColor?: string;
}

export default function SectionHeading({
  children,
  subtitle,
  className = "",
  headingColor = "text-gray-900",
  underlineColor = "bg-[#F4BF1A]",
  subtitleColor = "text-muted-foreground",
}: SectionHeadingProps) {
  return (
    <div className={`text-center space-y-4 ${className}`}>
      <h2 className={`text-4xl font-semibold ${headingColor}`}>{children}</h2>
      <div className={`w-20 h-1.5 rounded-full ${underlineColor} mx-auto`} />
      {subtitle && <p className={`text-lg ${subtitleColor} mt-4 font-normal`}>{subtitle}</p>}
    </div>
  )
}
